export default __webpack_public_path__ + "static/tb_radler_02_EN-5df2a5aeb7c3f25160abf7e23923b190.svg";